// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__25Xkv","title":"BackImages_title__3pMC1","images":"BackImages_images__35uei"};